module.exports = __webpack_public_path__ + "static/img/gayatri.8868c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gayatri.png
// module id = qdfA
// module chunks = 1